import styled from '@emotion/styled';

export const SCard = styled.div`
  width: 364px;
  background: white;
  padding: 20px;
  margin: 20px;
`;

export const SWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;
  color: black;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  height: 48px;
  padding-left: 32px;
  width: 377px;
`;

export const SInputWrapper = styled.div`
  .input-otp {
    justify-content: space-between;
    
    input {
      height: 40px;
      width: 40px;
    }
  }
`;
